// export const urlLogin = "http://www.dreamchimney.com/tracks/login";
// const base = process.env.NODE_ENV === "production" ? `http://www.dreamchimney.com` : `http://www.dc.local`;
import { getAuthHeader } from "~/utils/headers";

// @TODO migration node js api user-api is coming from react-axios package
// from  ->  /Users/ryanbishop/Sites/dreamchimney/packages/react-axios 
const base = ``;
const apiBase = `//www.dreamchimney.com/api`;

// uses php api
export const urlPasswordForgot = base + "/forgot";
export const urlPasswordReset = base + "/reset";
export const urlGetUser = apiBase + "/tracks/user";
export const urlUploadAvatar = apiBase + "/tracks/user/avatar";
export const urlUserApply = apiBase + "/tracks/apply";
// php version
export const urlUserValidate = apiBase + "/user/validate";
export const urlUserProfile = base + "/profile";
// export const urlUserProfileEditRead = base + "/profile/edit";
export const urlUserFavorites = base + "/favorites";
export const urlUserSocial = base + "/social";
// node express version, not used yet
// export const urlUserValidate = base + "/validate";

export const userValidate = (axios, urlUserValidate, vals) => axios.post(`${urlUserValidate}`, vals);
export const userPasswordForgot = (axios, vals) => axios.post(`${urlPasswordForgot}`, vals);
export const userPasswordReset = (axios, vals) => axios.post(`${urlPasswordReset}`, vals);
export const getUser = (axios, urlGetUser, vals) => axios.post(`${urlGetUser}`, vals);
export const postUserApplication = (axios, vals) => axios.post(`${urlUserApply}`, vals);

export const getUserProfile = (axios, userDir) => axios.get(`${urlUserProfile}?userDir=${userDir}`);
export const postGetUserFavorites = (axios, userDir, page = 1) => axios.post(`${urlUserFavorites}?userDir=${userDir}`, { userDir, page });
export const postAvatarUpload = (axios, formData) =>
  axios.post(`${urlUploadAvatar}`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });

export const postUserSocialSave = (axios, payload) => axios.post(`${urlUserSocial}`, payload, getAuthHeader());
// export const getUserProfileEdit = (axios, payload) => axios.post(`${urlUserProfileEditRead}`, payload);
